import React, { createContext, ReactNode, useContext, useState, useCallback, Dispatch, SetStateAction } from 'react';

interface HotKeysContextProps {
  keyMap: { [key: string]: string };
  handlers: { [key: string]: (event: KeyboardEvent) => void };
  showSearchModal: boolean;
  setShowSearchModal: Dispatch<SetStateAction<boolean>>;
}

interface HotKeysProviderProps {
  children: ReactNode;
}

export const HotKeysContext = createContext<HotKeysContextProps | undefined>(undefined);

export const HotKeysContextProvider: React.FC<HotKeysProviderProps> = ({ children }) => {
  const [showSearchModal, setShowSearchModal] = useState(false);

  const keyMap = {
    GLOBAL_SEARCH: 'command+k',
  };

  const handlers = {
    GLOBAL_SEARCH: useCallback((event: KeyboardEvent) => {
      event.preventDefault();
      setShowSearchModal(true);
      // Add analytics or other logic here if needed
    }, []),
  };

  return (
    <HotKeysContext.Provider value={{ keyMap, handlers, showSearchModal, setShowSearchModal }}>
      {children}
    </HotKeysContext.Provider>
  );
};

export const useHotKeysContext = (): HotKeysContextProps => {
  const context = useContext(HotKeysContext);
  if (context === undefined) {
    throw new Error('useHotKeysContext must be used within a HotKeysContextProvider');
  }
  return context;
};

export default HotKeysContextProvider;
